import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select']

  connect() {
    if (this.selectTarget.options.length <= 2 && !this.selectTarget.value) {
      if (this.selectTarget.name != 'accommodation') {
        this.selectTarget.disabled = 'disabled'
        this.element.classList.add('disabled')
        this.selectTarget.value =
          this.selectTarget.options.length == 2
            ? this.selectTarget.options[1].value
            : this.selectTarget.options[0].value
      }
    }
  }
  onResetHandler() {
    this.selectTarget.selectedIndex = 0
    this.selectTarget.dispatchEvent(new Event('change'))
  }
}
